const tour = {
  getStarted: "Get Started with <strong>MERU</strong>!",
  hereYouWillFind:
    "Here you will find a list of all equipment owned by your company.",
  smartSearch: "Smart Search Engine",
  ifYouWantToSearch:
    "If you want to search for a specific equipment by its tag you can use our smart search engine.",
  youCanExpandARow: "You can expand a row to find more equipment options",
  options:
    "The available options are to generate new inspections, reliability reports or simply view the <strong>DASHBOARD</strong> of this equipment.",
  goingToTheDashboard: "Going to the Dashboard",
  youCanAlsoUse:
    "You can going to this equipment's DASHBOARD, just try it, click on row.",
  navigationDrawerTitle: "Navigation Drawer (&#9776;)",
  navigationDrawerContent:
    "This is the navigation drawer, here you can go to other important routes within the application, such as your user profile or report an error, even scan a QR Code to make a new inspection or reliability report"
};
export default tour;
